import JsonLd from 'components/JsonLd';

/**
 * items: [{ name: string, url: string }, ...]
 * url может быть относительным (/ng/slug/) — в JSON-LD schema.org требует абсолютный URL.
 */
const toAbsolute = (url) =>
  url?.startsWith('http') ? url : window.location.origin + (url || '');

const BreadcrumbJsonLd = ({ items }) => {
  if (!items?.length) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": item.name,
      "item": toAbsolute(item.url)
    }))
  };

  return <JsonLd data={schema} />;
};

export default BreadcrumbJsonLd;
